<form class="dialog-container" [formGroup]="securityKeysForm">
  <div class="stepper-container" *ngIf="!isSuccessScreen && !isSecurityKeycreating">
    <div class="stepper-container-item" [ngStyle]="{ background: iskeyName ? '#25508E' : '#F3F6FA' }"></div>
    <div class="stepper-container-item" [ngStyle]="{ background: isSecurityKey ? '#25508E' : '#F3F6FA' }"></div>
    <div class="stepper-container-item" [ngStyle]="{ background: isHint ? '#25508E' : '#F3F6FA' }"></div>
    <div class="stepper-container-item-2" [ngStyle]="{ background: isSafeguardkey ? '#25508E' : '#F3F6FA' }"></div>
  </div>
  @if(isSecurityKey || isHint || isSafeguardkey){
  <div class="back-btn" (click)="backItem()">
    <button type="button" class="back-btn-for-security"><i class="material-icons back-arrow">arrow_back</i> Back</button>
  </div>
  }
  <div class="next-btn" (click)="nextItem()" *ngIf="!hidenextBtn">
    <div *ngIf="iskeyName">
      <button type="button" class="next-btn-for-security" [class.disable-button-continue]="!securityKeysForm.controls['keyname'].valid">
        <span style="display: flex; justify-content: center; align-items: center">Next <i class="material-icons next-arrow">arrow_forward</i></span>
      </button>
    </div>

    <div *ngIf="isSecurityKey">
      <button
        type="button"
        class="next-btn-for-security"
        [class.disable-button-continue]="
          securityKeysForm.controls['securitykey'].length == 0 ||
          !(securityKeysForm.controls['securitykey'].valid && securityKeysForm.controls['confirmSecurityKey'].valid) ||
          !equalPasswords()
        "
      >
        <span style="display: flex; justify-content: center; align-items: center">Next <i class="material-icons next-arrow">arrow_forward</i></span>
      </button>
    </div>

    <div *ngIf="isHint">
      <button type="button" class="next-btn-for-security" [class.disable-button-continue]="">
        <span style="display: flex; justify-content: center; align-items: center">Next <i class="material-icons next-arrow">arrow_forward</i></span>
      </button>
    </div>

    <div *ngIf="isSafeguardkey">
      <button type="button" class="next-btn-for-security" [class.disable-button-continue]="!this.securityKeysForm.controls['securityCheckbox'].value">
        <span style="display: flex; justify-content: center; align-items: center">Finish </span>
      </button>
    </div>
  </div>

  <!-- STEP1 KEYNAME -->
  <div class="security-step" *ngIf="iskeyName">
    <div class="security-step-keyName">
      <div style="display: block">
        <div class="security-img-container">
          <img src="../../../../../../../assets/images/security-key.svg" class="security-key-img" />
        </div>

        <div class="security-text-container">
          <h2 class="security-text-main">Give Your Key a Name</h2>
          <h2 class="security-sub-text">Give this Security Key a unique name for easy identification</h2>
        </div>

        <div class="keyname-input flex-col">
          <mat-form-field appearance="fill" subscriptSizing="dynamic" class="security-key-input relative">
            <mat-label class="automtic-form-desing-lable relative w-full contents"
              >Key Name

              <span class="absolute right-0"> {{ securityKeysForm.controls['keyname'].value.length }}/245 </span>
              
            </mat-label>

            <input matInput placeholder="Key Name" autocomplete="off" name="keyname " formControlName="keyname" required maxlength="245"  />
            <mat-error style="height: auto" *ngIf="securityKeysForm.controls['keyname'].value.length">Key Name cannot contain space.</mat-error>
          </mat-form-field>
          @if(securityKeysForm.controls['keyname'].value.length ==245) {
          <p class="show-error-forsecurity-key text-[#f44336] m-auto text-left mt-1 w-[400px]">You have reached the maximum character limit</p>
          }
        </div>
        <p
          class="flex items-center justify-center gap-1 text-[#70707066] mt-6"
          [ngClass]="{
            'text-[#70707066]': securityKeysForm.controls['keyname'].invalid,
            'text-k-blue': securityKeysForm.controls['keyname'].valid
          }"
        >
          <span class="material-icons text-[12px]">check_circle</span>
          Key needs to be at least 4 characters long
        </p>
      </div>
      <p class="cancel-key-setup" (click)="cancelkeySetup(iskeyName)">Cancel Key Setup</p>
    </div>
  </div>

  <!-- STEP2 SECURITY KEY -->
  <div class="security-step" *ngIf="isSecurityKey">
    <div class="security-step-SecurityKey">
      <div style="display: block">
        <div class="security-img-container">
          <img src="../../../../../../../assets/images/security-key.svg" class="security-key-img" />
        </div>

        <div class="security-text-container">
          <h2 class="security-text-main">Enter Your Security Key</h2>
          <h2 class="security-sub-text">Should be non obvious & difficult for others to guess</h2>
        </div>

        <div class="keyname-input">
          <mat-form-field appearance="fill" subscriptSizing="dynamic" class="security-key-input relative">
            <mat-label class="automtic-form-desing-lable relative w-full contents">
              New Key
              <span class="absolute right-0"> {{ securityKeysForm.controls['securitykey'].value?.length }}/245 </span>
            </mat-label>
            <input
              matInput
              autocomplete="off"
              name="New Security Key"
              maxlength="245"
              formControlName="securitykey"
              placeholder="New Security Key"
              required
              maxlength="245"
              [type]="!hidePasword ? 'password' : 'text'"
            />
            <span matIconSuffix class="icone-visibility" (click)="hidePasword = !hidePasword">
              <mat-icon class="m-2 mt-4 text-[16px]">{{ hidePasword ? 'visibility' : 'visibility_off' }}</mat-icon>
            </span>
          </mat-form-field>
          <div class="generate-key-container">
            <p class="generate-key" (click)="generateRandomKey(30)">Generate key</p>
          </div>

          <div class="key-container">
            <p class="show-error-forsecurity-key" [style.color]="securityKeysForm.controls['securitykey'].value.length >= 8 ? '#4868AF' : '#f44336'">
              <span *ngIf="securityKeysForm.controls['securitykey'].value.length < 8" class="material-icons small-red-icon">close</span>
              <span class="small-black-icon" *ngIf="securityKeysForm.controls['securitykey'].value.length >= 8"
                ><img src="../../../../../../../assets/images/check-for-security.svg" class="check-icon-security"
              /></span>
              Key needs to be at least 8 character long
            </p>
            <p
              class="show-error-forsecurity-key"
              [style.color]="checkUpperCase(securityKeysForm.controls['securitykey'].value) ? '#4868AF' : '#f44336'"
            >
              <span *ngIf="!checkUpperCase(securityKeysForm.controls['securitykey'].value)" class="material-icons small-red-icon">close</span>
              <span class="small-black-icon" *ngIf="checkUpperCase(securityKeysForm.controls['securitykey'].value)"
                ><img src="../../../../../../../assets/images/check-for-security.svg" class="check-icon-security"
              /></span>
              Uses at least one uppercase and lowercase letter
            </p>
            <p
              class="show-error-forsecurity-key"
              [style.color]="checSpecialCase(securityKeysForm.controls['securitykey'].value) ? '#4868AF' : '#f44336'"
            >
              <span *ngIf="!checSpecialCase(securityKeysForm.controls['securitykey'].value)" class="material-icons small-red-icon">close</span>
              <span class="small-black-icon" *ngIf="checSpecialCase(securityKeysForm.controls['securitykey'].value)"
                ><img src="../../../../../../../assets/images/check-for-security.svg" class="check-icon-security"
              /></span>
              Uses at least one special character like $#%&#64;&*
            </p>
            <p
              class="show-error-forsecurity-key"
              [style.color]="checkUnmericCase(securityKeysForm.controls['securitykey'].value) ? '#4868AF' : '#f44336'"
            >
              <span *ngIf="!checkUnmericCase(securityKeysForm.controls['securitykey'].value)" class="material-icons small-red-icon">close</span>
              <span class="small-black-icon" *ngIf="checkUnmericCase(securityKeysForm.controls['securitykey'].value)"
                ><img src="../../../../../../../assets/images/check-for-security.svg" class="check-icon-security"
              /></span>
              Uses at least one number
            </p>
          </div>
        </div>

        <div class="keyname-confirm-input">
          <mat-form-field
            appearance="fill"
            subscriptSizing="dynamic"
            class="security-key-input relative"
            [ngClass]="
              securityKeysForm.controls['confirmSecurityKey'].dirty &&
              securityKeysForm.controls['confirmSecurityKey'].touched &&
              securityKeysForm.controls['confirmSecurityKey'].invalid
                ? 'automtic-form-desing-error'
                : ''
            "
          >
            <mat-label class="automtic-form-desing-lable relative w-full contents">
              Confirm Key
              <span class="absolute right-0"> {{ securityKeysForm.controls['confirmSecurityKey'].value?.length }}/245 </span>
              
            </mat-label>
            <input
              matInput
              autocomplete="off"
              maxlength="245"
              formControlName="confirmSecurityKey"
              placeholder="Confirm Security Key"
              required
              maxlength="245"
              [type]="!hidePasword ? 'password' : 'text'"
            />
            <span matIconSuffix class="icone-visibility" (click)="hidePasword = !hidePasword">
              <mat-icon class="m-2 mt-4 text-[16px]">{{ hidePasword ? 'visibility' : 'visibility_off' }}</mat-icon>
            </span>
            <mat-error *ngIf="!equalPasswords()" style="height: auto; margin-top: 20px">The Security Keys you have entered do not match.</mat-error>
          </mat-form-field>
        </div>
      </div>

      <p class="cancel-key-setup" (click)="cancelkeySetup(iskeyName)">Cancel Key Setup</p>
    </div>
  </div>

  <!-- STEP3 HINT -->
  <div class="security-step" *ngIf="isHint">
    <div class="security-step-Hint">
      <div style="display: block">
        <div class="security-img-container">
          <img src="../../../../../../../assets/images/security-key.svg" class="security-key-img" />
        </div>

        <div class="security-text-container">
          <h2 class="security-text-main">Create a Hint</h2>
          <h2 class="security-sub-text">We highly recommend adding a hint to help you remember your key so it doesn’t get lost or forgotten.</h2>
        </div>

        <div class="hint-input">
          <mat-form-field appearance="fill" subscriptSizing="dynamic" class="security-key-input">
            <mat-label class="automtic-form-desing-lable">Hint (optional)</mat-label>
            <input matInput placeholder="Hint (optional)" formControlName="securityHint" autocomplete="off" name="securityHint" />
          </mat-form-field>
        </div>

        @if(whiteSpaceTrimForForm(securityKeysForm.controls['securityHint'].value) ===
        whiteSpaceTrimForForm(securityKeysForm.controls['confirmSecurityKey'].value) ){
        <p class="show-error-forsecurity-key text-[#f44336] m-auto text-left mt-1 w-[400px]">Cannot not be same as the Security Key</p>
        }
      </div>
      <p class="cancel-key-setup" (click)="cancelkeySetup(iskeyName)">Cancel Key Setup</p>
    </div>
  </div>
  <!-- STEP4 SAFEGAURD KEY -->
  <div class="security-step" *ngIf="isSafeguardkey">
    <div class="security-step-safegaurd">
      <div style="display: block">
        <div class="security-img-container">
          <img src="../../../../../../../assets/images/security-key.svg" class="security-key-img" />
        </div>

        <div class="security-text-container">
          <h2 class="security-text-main">Safeguard Your Key</h2>
          <h2 class="security-sub-text">Download or Copy this key for safekeeping</h2>
        </div>

        <div class="copy-container">
          <diV class="copy-link-text"> ******** </diV>
          <div class="copy-content-icon">
            <span (click)="openSecurityKeyDialog()" class="material-icons eye-content">remove_red_eye</span>
            <span (click)="copy()" class="material-icons copy-content">content_copy</span>
            <span class="material-icons download-content" (click)="downloadFile()">download</span>
          </div>
        </div>

        <div class="download-container-mobile">
          <button type="button" class="dowmload-btn-mobile" (click)="downloadFile()">
            <span class="material-icons download-content">download</span> Download
          </button>
        </div>

        <div class="consent-box">
          <div class="consent-checkbox">
            <mat-checkbox type="checkbox" style="position: relative; right: 10px" formControlName="securityCheckbox" class="security-checkbox">
              <mat-label class="consent-text">
                I understand that if I lose or forget this security key, Kinnect cannot recover this key or any files that I protect with this key.
              </mat-label>
            </mat-checkbox>
          </div>
        </div>
      </div>
      <p class="cancel-key-setup" (click)="cancelkeySetup(iskeyName)">Cancel Key Setup</p>
    </div>
  </div>

  <!-- security key creation animation-->
  <div *ngIf="isSecurityKeycreating" class="security-key-creation">
    <p class="security-key-creation-text">Please wait while your <span class="security-key-creation-subtext">Security Key</span> is generated</p>
    <div class="security-key-creation-animation">
      <ng-lottie [options]="successAnimationOptionsKey"></ng-lottie>
    </div>
    <p class="security-key-creation-time">We’re working to secure your account, this can take up to 15 seconds</p>
  </div>

  <!-- animation -->
  <div *ngIf="isSuccessScreen" class="success-screen">
    <p class="success-screen-text">Your <span class="success-screen-subtext">Security Key</span> Has Been Setup</p>

    <div class="success-animation">
      <ng-lottie [options]="successAnimationOptions"></ng-lottie>
    </div>
  </div>
</form>
